import React, { useContext } from "react"
import lodash from "lodash"

import { useCustomer } from "components/Customer"

export default () => {
  const { currentCustomer } = useCustomer()

  return () => ({
    country: lodash.get(currentCustomer, "defaultCountry"),
    value: {
      value: "0",
      currency: lodash.get(currentCustomer, "defaultCurrency", "EUR")
    }
  })
}
